import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../core/common';
import { IGetSampleProductOrderHeader, ISampleProductOrderHeader, ISampleProductOrderDetails } from '../../../../../core/models';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";

@Component({
  selector: 'app-sample-request-order-history',
  templateUrl: './sample-request-order-history.component.html',
  styleUrls: ['./sample-request-order-history.component.scss']
})
export class SampleRequestOrderHistoryComponent implements OnInit {
  filterOrderHeaderForm: FormGroup;
  filterSaveInProcess: boolean;
  orderHeaderGridData: GridDataResult;
  orderGridData: any[] = [];
  orderLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  filterValidateMessage: boolean;
  //#region label declaration  

  protected orderLblText = {
    contactLbl: 'Contact',
    customerLbl: 'Customer',
    ccEmailLbl: 'CC Email',
    regionLbl: 'Region',
    createdDateLbl: 'Order Date',
    sampleProductOrderNumberLbl: 'Order Number',
    costLbl: 'Cost',
    exportToExcelLbl : 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Product',
    startDateLbl: 'Start Date',
    endDateLbl: 'End Date',
    filterInfoMsgLbl: 'Please Select Start Date and End Date',
    filterButtonLbl: 'Filter'
  };
  //#endregion
  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService, private cp: CurrencyPipe
  ) { }

  ngOnInit() {
    this.initializeFormControls();
  }
  initializeFormControls() {
    this.filterOrderHeaderForm = this.formBuilder.group({
      startDate: new FormControl(),
      endDate: new FormControl(),
    });
    let todaysDate = new Date();
    let priorDate = new Date(new Date().setDate(todaysDate.getDate() - 30));
    this.filterOrderHeaderForm.controls.startDate.setValue(priorDate);
    this.filterOrderHeaderForm.controls.endDate.setValue(todaysDate);
    this.getFilterOrderHeader();
  }

  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public orderGridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.orderGridData, this.orderGridstate),
    columnsConfig: [{
      field: 'sampleProductOrderNumber',
      title: this.orderLblText.sampleProductOrderNumberLbl,
      filterable: true,
      widthForPDF: 80,
      _width: 150,
    },
    {
      field: 'customer',
      title: this.orderLblText.customerLbl,
      filterable: true,
      widthForPDF: 100,
      _width: 220,
    },
    {
      field: 'createdDate',
      title: 'Order Date',//this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderSelectionGridLbl.orderDatelbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 220,
      filterable: true,
      widthForPDF: 80,
    }, {
      field: 'contact',
      title: this.orderLblText.contactLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 100,
      _width: 150,
    }
      , {
      field: 'cost',
      title: this.orderLblText.costLbl,
      filterable: true,
      widthForPDF: 60,
      _width: 130,
    }
      ,
    {
      field: 'region',
      title: this.orderLblText.regionLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 60,
      _width: 130,
    }
    ]
  };


  getFilterOrderHeader() {
    this.filterValidateMessage = false;
    this.orderLoading = true;
    if (!this.validatefilterOrderHeaderForm()) {
      this.filterValidateMessage = true;
      return;
    }

    var controls = this.filterOrderHeaderForm.controls;
    const body: IGetSampleProductOrderHeader = {
      startDate: controls.startDate.value,
      endDate: controls.endDate.value
    }
    this.productSampleFulfillmentService.getSampleProductOrderHeader(body).subscribe((response: Array<any>) => {
      if (response) {
        this.orderGridData = response;
        this.productSampleFulfillmentService.setOrderHeaderGridData(this.orderGridData);
        this.loadOrderHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Soory an error occured while loading the page.');
    })
    this.orderLoading = false;
  }

  private loadOrderHeaderGridData(): void {
    if (this.orderGridSettings.state)
      this.orderHeaderGridData = process(this.orderGridData, this.orderGridSettings.state);
    else
      this.orderHeaderGridData = process(this.orderGridData, this.orderGridstate);
    this.orderGridSettings.gridData = this.orderHeaderGridData;
  }
  protected orderHeaderGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.loadOrderHeaderGridData();
  }

  protected orderHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.loadOrderHeaderGridData();
  }

  public orderHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.orderGridSettings.state = this.orderGridstate;
    this.loadOrderHeaderGridData();
  }
  proceedToSampleProductDetails(dataItem: ISampleProductOrderHeader) {
    this.productSampleFulfillmentService.setSingleOrderHeaderGridData(dataItem);
    this.router.navigate(['sample-request-admin/sample-request-order-history2/order-details/'+dataItem.id]);
  }
  
  validatefilterOrderHeaderForm() {
    let isValid = true;
    const controls = this.filterOrderHeaderForm.controls;
    if (controls.startDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    if (controls.endDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    return isValid;
  }
  generateExcel() {
    this.loadingExcel = true;
    var controls = this.filterOrderHeaderForm.controls;
    var currFilter = this.orderGridSettings.state.filter;
    var filterData = process(this.orderGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.orderGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [
      this.orderLblText.sampleProductOrderNumberLbl,
      this.orderLblText.customerLbl,
      this.orderLblText.createdDateLbl,
      this.orderLblText.contactLbl,
      this.orderLblText.costLbl,
      this.orderLblText.regionLbl
    ];
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', this.orderLblText.startDateLbl + ": " + toDate]);
    worksheet.addRow(['', '', this.orderLblText.endDateLbl + ": " + fromDate]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let orderDetailsRow = worksheet.addRow([this.orderLblText.sampleProductLbl]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    
    dataArray.map(p =>
    ([
      p.sampleProductOrderNumber ? p.sampleProductOrderNumber : '',
      p.customer ? p.customer : '',
      p.createdDate ? p.createdDate : '',
      p.contact ? p.contact : '',
      p.cost ? this.cp.transform(p.cost, 'USD', true, '1.2-2') : '',
      p.region ? p.region : '',
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleProductOrderHeader.xlsx');
    })
    this.loadingExcel = false;
  }
  async generatePDF() {
    //debugger;
    this.loadingPDF = true;
    var controls = this.filterOrderHeaderForm.controls;
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    var currFilter = this.orderGridSettings.state.filter;
    var filterData = process(this.orderGridData, {
      filter: currFilter
    });
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.orderGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      if (c.title === this.orderLblText.createdDateLbl)
        fieldOutput.push("createdDateUIString");//temp fix. Need to remove.      
      else
        fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });    
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.orderLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: this.orderLblText.startDateLbl + ": " + toDate,
              bold: true,
              margin: [0, 2, 0, 2]
            },
            {
              text: this.orderLblText.endDateLbl + ": " + fromDate,
              bold: true,
              margin: [0, 2, 0, 2]
            }],
          ]
        },
        {
          text: "Sample Product Order List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,
            body: [
              [
                this.orderLblText.sampleProductOrderNumberLbl,
                this.orderLblText.customerLbl,
                this.orderLblText.createdDateLbl,
                this.orderLblText.contactLbl,
                this.orderLblText.costLbl,
                this.orderLblText.regionLbl
              ],
              ...dataArray.map(p =>
              ([
                p.sampleProductOrderNumber ? p.sampleProductOrderNumber : '',
                p.customer ? p.customer : '',
                p.createdDateUIString ? p.createdDateUIString : '',
                p.contact ? p.contact : '',
                p.cost ? this.cp.transform(p.cost, 'USD', true, '1.2-2') : '',
                p.region ? p.region : '',
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('SampleProductOrderHeader.pdf');
    this.loadingPDF = false;
  }
}
